import { Component, input, computed } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { HtmlPipe } from '../../html.pipe';
@Component({
    selector: 'app-blog-detail',
    templateUrl: './blog-detail.component.html',
    styleUrls: ['./blog-detail.component.scss'],
    imports: [CommonModule, HtmlPipe, NgOptimizedImage],
    standalone: true
})
export class BlogDetailComponent {
    blog = input.required<any>();
    authors = computed(() => {
        const authors = this.blog().authors ?? [];
        return authors.map((author) => {
            const path = author.image?.[0]?.path;
            return {
                ...author,
                image: path,
            };
        });
    });
}
